import { render, staticRenderFns } from "./EmployeePayslipDetails.vue?vue&type=template&id=943c0392&scoped=true"
import script from "./EmployeePayslipDetails.vue?vue&type=script&lang=js"
export * from "./EmployeePayslipDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeePayslipDetails.vue?vue&type=style&index=0&id=943c0392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943c0392",
  null
  
)

export default component.exports